import { useState } from "react";

export const useGlobalExpandNavItemData = () => {
  const [open, setOpen] = useState(false);

  const handleToggle = () => {
    setOpen((prev) => !prev);
  };

  return {
    open,
    handleToggle,
  };
};
